import { render } from "./AgeGate.vue?vue&type=template&id=4663d573&scoped=true&ts=true"
import script from "./AgeGate.vue?vue&type=script&lang=ts"
export * from "./AgeGate.vue?vue&type=script&lang=ts"

import "./AgeGate.vue?vue&type=style&index=0&id=4663d573&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4663d573"]])

export default __exports__